export default __webpack_public_path__ + "static/media/success.e7b05515.svg";